module.exports = __webpack_public_path__ + "img/yxlx-2.c5fecc7a.jpg";